// extracted by mini-css-extract-plugin
export var errorsContainer = "_q6-1";
export var link = "_q6-0";